import { LanguageType } from '../components'
// Dont change this import to from '../components', otherwise everything will break in tests!!!
import { LangText, LangValue } from '../components/types/enums'

export const DEFAULT_UI_LANGUAGE_VALUE = LangValue.FI

export const DEFAULT_UI_LANGUAGE_TEXT = LangText.FI

export const DEFAULT_UI_LANGUAGE: LanguageType = {
  value: DEFAULT_UI_LANGUAGE_VALUE,
  text: DEFAULT_UI_LANGUAGE_TEXT
}

export const UI_LANGUAGES: LanguageType[] = [
  DEFAULT_UI_LANGUAGE,
  {
    value: LangValue.EN,
    text: LangText.EN
  },
  {
    value: LangValue.SV,
    text: LangText.SV
  }
]
